module.exports = __webpack_public_path__ + "media/d28ecb6f1d924232ba6aa860359dcb9f.af224c5c.webm";